<template>
  <div class="empreendimentos" v-if="empreendimentosDestaques.length">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-md-7 col-12">
          <h1 class="ui-home-title ui-home-title--white">
            Nossos
            <b>
              Empreendimentos
            </b>
          </h1>
        </div>
        <div class="col-xl-5 col-md-5 col-12">
          <div class="empreendimentos__filter">
            <img src="../assets/img/icon-filter.png" alt="Filtro"> Filtre os empreendimentos
          </div>
          <div class="empreendimentos__filter--item" v-for="(item,index) in empreendimentosFiltros" :key="index">
            <router-link :to="{name: 'Empreendimentos', query: { filter: item.id }}">
              <img v-if="item.image" :src="item.image" alt="Filtro"> {{item.name}}
            </router-link>
          </div>
        </div>
        <div class="col-12 d-none d-lg-block">
          <div class="empreendimentos__spacing"></div>
        </div>
      </div>
      <EmpreendimentosCard :empreendimentos="empreendimentosDestaques"></EmpreendimentosCard>
      <KnowMore></KnowMore>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EmpreendimentosCard from './HomeEmpreendimentosCard.vue'
import KnowMore from './KnowMore.vue'
export default {
  components: {
    EmpreendimentosCard,
    KnowMore
  },
  computed: {
    ...mapGetters([
      'empreendimentosDestaques',
      'empreendimentosFiltros'
    ])
  },
  created () {
    this.$store.dispatch('loadEmpreendimentosDestaques')
    this.$store.dispatch('loadEmpreendimentosFiltros')
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.empreendimentos {
  background: linear-gradient(0deg, white 55%,$primary 0);
  padding: 80px 0;
  &__filter {
    color: $green;
    font-size: 24px;
    font-weight: 900;
    margin-bottom: 50px;
    img {
      margin-right: 10px;
      margin-top: -5px;
    }
  }
  &__filter--item {
    margin-bottom: 30px;
    a {
      color: white;
      font-size: 18px;
      font-style: italic;
      opacity: 0.5;
      text-transform: uppercase;
      transition: all 0.3s;
      &:hover {
        font-style: inherit;
        font-weight: bold;
        opacity: 1;
        transition: all 0.3s;
      }
      img {
        margin-right: 10px;
        margin-top: -15px;
      }
    }
  }
  &__spacing {
    margin-bottom: 70px;
  }
  @media (max-width: 1200px){
    &__spacing {
      margin-bottom: 50px;
    }
  }
  @media (max-width: 991px){
    &__spacing {
      margin-bottom: 40px;
    }
    &__filter {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 30px;
    }
    padding: 60px 0;
  }
  @media (max-width: 767px){
    padding: 40px 0;
    &__filter {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeEmpreendiments.vue